"use client";

import { useEffect, useState } from "react";
import * as Sentry from "@sentry/nextjs";

export default function SignupError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  const [errorID, setErrorID] = useState<string | null>(null);
  useEffect(() => {
    const r = Sentry.captureException(error);
    setErrorID(r);
  }, [error]);

  return (
    <>
      <h1 className="text-2xl font-bold">Sorry, something went wrong</h1>
      <p>
        Something went wrong on our end. Your answers so far have been saved.
      </p>
      <p>
        Please try refreshing the page or try again later. If you still have
        trouble, please contact us at{" "}
        <a href="mailto:roses@ystv.co.uk" className="font-bold">
          roses@ystv.co.uk
        </a>
        .
      </p>
      {errorID ? (
        <p>
          This error has been logged and we will look into it. If you get in
          touch with us, please reference the following error ID:{" "}
          <code>{errorID}</code> and digest{" "}
          <code>{error.digest ?? "0"}</code>.
        </p>
      ) : null}
    </>
  );
}
